import React, { useState ,useEffect} from "react";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from "@mui/material/TablePagination";
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import MainContainer from '../../components/MainContainer';
import { headerDataAssignment } from '../../data/modules/assignment-header';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Title from '../../components/Title';
import Spacer from '../../components/Spacer';
import DirectionService from "../../services/DirectionService";
import PlanningService from "../../services/PlanningService";
import SearchIcon from '@mui/icons-material/Search';
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import UserNotactifService from "../../services/UserNotactifService";
import CircularProgress from "@mui/material/CircularProgress";
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon
} from '@mui/icons-material';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button
} from "@material-ui/core";
import UserService from "../../services/UserService";


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    elevation: 0
  },
}));



function Row(props) {
  const { row } = props;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const handleToggle = async () => {
    if (!open) {
      setLoading(true);
      try {
           UserNotactifService.detailperson(row.userid).then((result) => {
          if (result && result.data) {
             setHistory(result.data);
             setLoading(false);
          } else {
             setHistory([]);
             setLoading(false);
          }
        });
      
      } catch (error) {
        setHistory([]);
      } finally {
        setLoading(false);
      }
    }
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={handleToggle}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">{row.name}</TableCell>
        <TableCell align="center">{row.fonction}</TableCell>
        <TableCell align="center">{row.matricule}</TableCell>
        <TableCell align="center">{row.telephone}</TableCell>
        <TableCell align="center">{row.email}</TableCell>
        <TableCell align="center">{row.funding}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Historique
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


Row.propTypes = {
  row: PropTypes.shape({
    fonction: PropTypes.number.isRequired,
    telephone: PropTypes.number.isRequired,
    matricule: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    funding: PropTypes.number.isRequired,
    email: PropTypes.number.isRequired,
  }).isRequired,
};

 function createData(userid,name, fonction, matricule, telephone, email, funding) {
        return {
            userid,
            name,
            fonction,
            matricule,
            telephone,
            email,
            funding,
            history: [],
        };
 }


export default function HistoryValidation() {
      const classes = useStyles();
        const [page, setPage] = useState(0);
        const [rows,setRows]=useState([]);
        const [rowsPerPage, setRowsPerPage] = useState(5); 

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };


        const visibleRows = rows.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );
      const[direction,setDirection]=useState([]);
      const [service,setService]=useState([]);
      const [form, setForm] = useState({
            direction_id:localStorage.getItem("USER_DIR"),
            service_id: 0
      });
      const [iddir,setIddir]=useState(0);
      const [idservice,setIdservice]=useState(0);
      const [filters, setFilters] = useState({
          direction_id: localStorage.getItem("USER_DIR"),
          service_id: 0
      });
 
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  function handleChangeDirection(event) {
    const { name, value } = event.target;
        setForm({ ...form, [name]: value });
        setIddir(value);
    }

    function handleChangeService(ev) {
        const { name, value } = ev.target;
        setForm({ ...form, [name]: value });
        setIdservice(value);
    }

    const handleSubmit = () => {
      setFilters({
        direction_id: form.direction_id,
        service_id: form.service_id
      });
   };
  

    useEffect(() => {
        setIddir(localStorage.getItem("USER_DIR"));
        DirectionService.getDirection().then((res) => {
              if (res && res.status) {
                setDirection(res.data);
              }
        });
        
    }, []);

     useEffect(() => {
          if (iddir !== 0 && iddir !== "") {
            PlanningService.Direction(iddir).then((results) => {
              if (results && results.data) {
                setService(results.data);
              }
            })
    
          }
    }, [iddir]);

     function loadAllUser() {
        setOpenLoadingSimpleBackdrop(true);
         UserService.getAllUserlist(filters.direction_id,filters.service_id).then((result) => {
          if (result && result.data) {
           setRows(
            result.data.map((row) =>
                createData(
                row.user_id,
                row.full_name,
                row.function_name,
                row.registration_number,
                row.telephone,
                row.email,
                row.funding
                )
            )
            );
            setOpenLoadingSimpleBackdrop(false);
          } else {
            setRows([]);
            setOpenLoadingSimpleBackdrop(false);
          }
        });
      }

       useEffect(() => {
         loadAllUser();
      }, [filters.direction_id,filters.service_id]);

  return (
    <MainContainer {...headerDataAssignment}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      startIcon={<SearchIcon />}
                      style={{ fontWeight: 800 ,width:170}}
                   >
                     Filtrer
                  </Button>
                <Spacer y={4} />
              <Grid container spacing={3} justifyContent="center">
                      <Grid item xs={12} md={5} sm={6} lg={5}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="demo-simple-select-outlined-label">Direction</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            label="Direction"
                            value={form.direction_id}
                            name="direction_id"
                            onChange={handleChangeDirection}
                          >
                            <MenuItem value={0}>Toutes</MenuItem>
                            {direction.map((row) => (
                              <MenuItem key={row.direction_id} value={row.direction_id}>
                                {row.code}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={5} sm={6} lg={5}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="demo-simple-select-outlined-label">Service</InputLabel>
                          <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" label="Service" value={form.service_id} name="service_id" onChange={handleChangeService} >
                            <MenuItem value={0}> Tous </MenuItem>
                            {service.map((row) => (
                              <MenuItem key="{row.service_id}" value={row.service_id}>{row.code}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
      
                      </Grid>
            </Grid>
      <Grid container spacing={3}>     
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
             <Title style={{ textAlign: "center" }}>Liste des utilisateurs</Title>
             <Spacer y={2} />
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                    <TableCell />
                    <TableCell>Nom et prénom(s)</TableCell>
                    <TableCell align="center">Fonction</TableCell>
                    <TableCell align="center">Matricule</TableCell>
                    <TableCell align="center">Téléphone</TableCell>
                    <TableCell align="center">Email</TableCell>
                    <TableCell align="center">Financement</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {visibleRows.map((row) => (
                    <Row key={row.id || row.registration_number} row={row} />
                    ))}
                </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Lignes par page"
            />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}